import React from 'react'
import {Chip } from "@mui/material";

const chipStyles = {
  position: "relative",       // ✅ Add this
  border: "2px solid #E2E2E2",
  borderRadius: '8px',
  padding: "8px 10px",
  fontSize: '14px',
  fontWeight: '400',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px'
};

const recommendedChipStyle =  {
  position: "absolute",
  top: -11,
  right: -8,
  background: "linear-gradient(90deg, #FFB347 0%, #FFCC33 100%)",
  color: "#5A3B00",
  fontWeight: 600,
  fontSize: "10px",
  borderRadius: "10px",
  height: "20px",
  border: "none",
  boxShadow: "0px 2px 4px rgba(0,0,0,0.15)",
  "& .MuiChip-label": { padding: "0 8px" },
};

const ModeChip = ({ textColor = '0F0F0F',isRecommended, text, icon, style, className = '', children, ...restProps }) => {
  return (
    <div
      className={className}
      style={{
        ...chipStyles,
        color: textColor,
        ...style
      }}
      {...restProps}
    >
      {icon}
      <div>
        {text ? text : children}
      </div>
      {isRecommended && (
        <Chip
          label="Recommended"
          size="small"
          sx={recommendedChipStyle }
        />
      )}
    </div>
  )
}

export default ModeChip